export const environment = {
  production: false,
  recaptcha: { siteKey: '6Le3yDwUAAAAALgkwPt8DzLin8nksZZk3CUeGkLg' },
};
